module.exports = __webpack_public_path__ + "static/media/endingPoint.f37c897e.svg";